<template>
  <div>
      <b-modal id="modal-delivery-input"
                  :title="status | statusTranslate"
                  centered
                  hide-footer
                  no-enforce-focus>
            <ValidationObserver ref="form">
              <form @submit.prevent>
              <div v-if="status === 'DELIVERED'">
                  <div class="row">
                      <b-col md="12">
                          <AGCInput
                              v-model.trim="deliveryCompany"
                              name="速遞公司"
                              label="速遞公司"
                              rules="required|max:50"
                              class="mb-3"
                              placeholder="請輸入速遞公司名稱"
                              required
                              :disabled="loading"
                              autofocus
                          ></AGCInput>
                      </b-col>
                      <b-col md="12">
                          <AGCInput
                              v-model.trim="deliveryOrderId"
                              name="運單編號"
                              label="運單編號"
                              rules="required|max:50"
                              class="mb-3"
                              placeholder="請輸入運單編號"
                              required
                              :disabled="loading"
                              autofocus
                          ></AGCInput>
                      </b-col>
                  </div>
              </div>
              <div v-else>
                  <div class="row">
                      <b-col md="12">
                          <AGCTextarea
                              v-model.trim="delayedRemarks"
                              name="備註"
                              label="備註"
                              subLabel="(最多30字)"
                              rules="required|max:30"
                              class="mb-3 remarks"
                              placeholder="可輸入預計發貨日期"
                              required
                              :disabled="loading"
                              autofocus
                          ></AGCTextarea>
                      </b-col>
                  </div>
              </div>
              <div class="row">
                  <span style="font-size:12px;padding:0px 15px;">*確認後，會以電郵書面通知買家。</span>
              </div>
              <div class="row">
                  <div class="action">
                      <b-button variant="outline-secondary"
                              :disabled="loading"
                              class="cancel"
                              @click="$bvModal.hide('modal-delivery-input')">
                      取消
                      </b-button>
                      <b-button
                          variant="success"
                          class="next"
                          type="submit"
                          :disabled="loading"
                          v-stream:click="onInputSubmit$">
                      確認
                      </b-button>
                  </div>
              </div>
            </form>
              </ValidationObserver>
              <UpdateSuccessModal v-model="updateSuccessModal"></UpdateSuccessModal>
              <LoadingSpinner v-if="loading"></LoadingSpinner>
      </b-modal>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import AGCInput from '@/components/form/AGCInput.vue';
import AGCTextarea from '@/components/form/AGCTextarea.vue';
import { tap, switchMap } from 'rxjs/operators';
import {
  BButton,
  BCol,
} from 'bootstrap-vue';
import UpdateSuccessModal from '@/components/delivery-status/UpdateSuccessModal.vue';
import { getErrorMsg } from '@/helpers/error-msg';
import formMixin from '@/mixins/form';
import http from '../../helpers/http';
import toastSettings from '../../helpers/toast-settings';

export default {
  mixins: [formMixin],
  props: ['status', 'redemptionItem', 'role'],
  components: {
    BButton,
    AGCInput,
    BCol,
    AGCTextarea,
    UpdateSuccessModal,
    LoadingSpinner,
  },
  filters: {
    statusTranslate: (value) => {
      if (!value) return '';
      switch (value) {
        case 'DELIVERED':
          return '已發貨';
        case 'DELAYED':
          return '發貨延誤';
        default:
          return '待發貨';
      }
    },
  },
  data: () => ({
    deliveryCompany: '',
    deliveryOrderId: '',
    delayedRemarks: '',
    loading: false,
    updateSuccessModal: {
      modal: false,
      action: null,
      remarks: null,
      msg: '已更新送貨狀態',
    },
  }),
  domStreams: ['onInputSubmit$'],
  subscriptions() {
    return {
      inputSubmit: this.onInputSubmit$.pipe(
        switchMap(this.validate),
        tap(() => {
          this.loading = true;
        }),
        switchMap(() => http({
          method: 'POST',
          url: `/agc-${this.role}-api/salesorder/updateDeliveryStatus`,
          data: {
            orderId: this.deliveryOrderId,
            company: this.deliveryCompany,
            remarks: this.delayedRemarks,
            status: this.status,
            redemptionItem: this.redemptionItem,
          },
        }, {
          error: ({ data: { msg } }) => {
            this.$bvToast.toast(getErrorMsg(msg), {
              ...toastSettings,
              title: '錯誤',
              toaster: 'b-toaster-top-center',
            });
          },
          next: (res) => {
            if (res) {
              this.updateSuccessModal.modal = true;
              this.deliveryOrderId = '';
              this.deliveryCompany = '';
              this.delayedRemarks = '';
            }
          },
          complete: () => {
            this.loading = false;
            this.$emit('update', this.status);
          },
        })),
      ),
    };
  },
};
</script>

<style scoped lang="scss">
::v-deep {
    .modal{
        &-dialog {
            max-width: 700px;
        }

        &-header {
            padding: 20px;
            border: none;
        }

        &-title {
            margin: 0 auto;
            font-size: 18px;
            font-weight: 400;
            color: #3a4047;
        }

        &-header .close {
            margin: 0px;
            padding: 0px;
            font-size: 20px;
        }

        &-body {
            padding: 0 24px 24px 24px;
        }

        &-body .col-12 {
            padding: 0;
            text-align: right;
        }
    }

    .action {
      text-align: right;
      width: 100%;
      padding: 0px 15px;
      button {
          width: 114px;
          height: 42px;
          display: inline-block;
          margin-left: 15px;
      }
    }

    .remarks{
        textarea{
            height: 92px;
        }
    }
}
</style>
